import './index.css';
import MyContestTab from '../my_contest_tab';
import MyTeamsTab from '../my_teams_tab';
import MyTeamsListSubstituteTab from '../../substitute/my_teams_tab';
import ContestTab from '../contest_tab';
import { HomeTabBar } from '../../component';
import SwipeableViews from 'react-swipeable-views';
import Constants from '../../../constants';
import DefaultContainer from '../../../container/default_container';
import constants from '../../../constants';
import FantasyHeader from '../../../component/fantasy_header';

const HomeTabWeb = ({
  gameType,
  matchItem,
  onCalledDeadline,
  fantasyCricketMyTeamsList,
  fantasyFootballMyTeamsList,
  fantasyCricketMyContestList,
  fantasyFootballMyContestList,
  activeTab,
  onChangeTab,
  routes,
  onChangeIndex
}: any) => {
  return (
    <DefaultContainer isWelcomeMessage={false}>
      <div className="home_tab_wrapper">
        <div className="fantasy-cricket-primary-container">
          <FantasyHeader
            matchItem={matchItem}
            onCalledDeadline={onCalledDeadline}
            gameType={gameType}
          />
          <div className="fantasy__homeTab__wrapper ">
            <HomeTabBar
              myTeamCount={
                gameType === constants.GameType.FANTASY_CRICKET
                  ? fantasyCricketMyTeamsList[matchItem['_id']]?.length
                  : gameType === constants.GameType.FANTASY_FOOTBALL
                  ? fantasyFootballMyTeamsList[matchItem['_id']]?.length
                  : 0
              }
              myContestsCount={
                gameType === constants.GameType.FANTASY_CRICKET
                  ? fantasyCricketMyContestList[matchItem['_id']]?.length
                  : gameType === constants.GameType.FANTASY_FOOTBALL
                  ? fantasyFootballMyContestList[matchItem['_id']]?.length
                  : 0
              }
              activeTab={activeTab}
              onChangeTab={onChangeTab}
              routes={routes}
            />
          </div>
        </div>
        <SwipeableViews
          className="fantasy-cricket-secondary-container"
          style={{ height: '80%', alignItems: 'center !important', overflowY: 'scroll' }}
          disableLazyLoading={true}
          index={activeTab}
          onChangeIndex={onChangeIndex}>
          <ContestTab />

          <MyContestTab />
          {gameType === Constants.GameType.FANTASY_SUBSTITUTION ? (
            <MyTeamsListSubstituteTab />
          ) : (
            <MyTeamsTab />
          )}
        </SwipeableViews>
      </div>
    </DefaultContainer>
  );
};

export default HomeTabWeb;
